import { Box } from '@mui/material'
import { Button } from '@evocolabs/orkaui'
import { Typography } from '@evocolabs/orkaui'
import styles from 'pages/scss/BuyOrkaTwo.module.scss'

const data = {
  title: 'Your reliable and warm-hearted hearing companion',
  subtitle: 'Hear better, and save more for a limited time.',
  btnText: 'Buy Now with Risk-Free Trial',
  sectionId: 'explore-orka-two-first-screen'
}

function Hero() {
  return (
    <Box className={styles.orkaTwoPoster} id={data.sectionId}>
      <Box>
        <img
          // eslint-disable-next-line max-len
          src="https://hiorka-storage.s3.us-west-2.amazonaws.com/website/buy-orka-two/V2/PC/orkaTwoLogo.svg"
          alt="OrkaTwoLogo"
        />
        <Typography
          variant="body1"
          component="p"
          sx={{ color: '#fff', mt: '32px' }}
        >
          {data.title}
        </Typography>
      </Box>
    </Box>
  )
}

export default Hero
